export default __webpack_public_path__ + "static/media/filter_activity_light.6d04e7f7.svg";